import { motion } from "framer-motion";
import { ArrowDown, Phone, MessageCircle } from "lucide-react";
import { BUSINESS, HERO_IMAGE } from "../data/content";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};
const item = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      {/* background layers */}
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_IMAGE}
          alt=""
          className="w-full h-full object-cover opacity-25"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/70 via-navy/85 to-navy" />
        <div className="absolute inset-0 grid-pattern opacity-60" />
        <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-signal/10 blur-[140px]" />
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-32 pb-20 w-full">
        <motion.div variants={container} initial="hidden" animate="show" className="max-w-4xl">
          <motion.p variants={item} className="font-mono text-xs md:text-sm tracking-[0.3em] uppercase text-signal mb-6">
            // Digital agency · Perth, Western Australia
          </motion.p>

          <motion.h1
            variants={item}
            data-testid="hero-headline"
            className="font-display text-5xl md:text-6xl lg:text-7xl tracking-tighter font-bold text-white leading-[1.05]"
          >
            We design &amp; develop
            <br />
            <span className="text-gradient-orange">customised</span> web
            <br />
            applications
          </motion.h1>

          <motion.p variants={item} className="mt-8 text-lg md:text-xl text-muted leading-relaxed max-w-2xl">
            Hylyte Digital is your one-stop shop for everything digital — 100% Australian made, original
            custom work, built closely with you every step of the way.
          </motion.p>

          <motion.div variants={item} className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-enquire"
              className="inline-flex items-center gap-2 rounded-full bg-signal px-7 py-3.5 font-semibold text-white hover:bg-signal-hover transition-colors duration-200 neon-glow"
            >
              Start a project
              <ArrowDown size={16} />
            </a>
            <a
              href={BUSINESS.phoneHref}
              data-testid="hero-cta-call"
              className="inline-flex items-center gap-2 rounded-full glass px-7 py-3.5 font-semibold text-white hover:border-signal transition-colors duration-300"
            >
              <Phone size={16} className="text-signal" />
              {BUSINESS.phone}
            </a>
            <a
              href={BUSINESS.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="inline-flex items-center gap-2 rounded-full glass px-7 py-3.5 font-semibold text-white hover:border-signal transition-colors duration-300"
            >
              <MessageCircle size={16} className="text-signal" />
              WhatsApp us
            </a>
          </motion.div>

          <motion.div variants={item} className="mt-16 flex flex-wrap gap-x-10 gap-y-4 font-mono text-xs tracking-[0.2em] uppercase text-muted">
            <span>100% Australian made</span>
            <span className="text-signal">//</span>
            <span>Custom original work</span>
            <span className="text-signal">//</span>
            <span>One-stop digital shop</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
